var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuArchives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-archives") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-archives",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive",
    transform: "translate(3.000000, 5.000000)",
    stroke: "#646464",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "16.3636364 4.09090909 16.3636364 14.7272727 1.63636364 14.7272727 1.63636364 4.09090909"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 4.09090909
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.36363636,
    y1: 7.36363636,
    x2: 10.6363636,
    y2: 7.36363636,
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArchives);
export default __webpack_public_path__ + "static/media/menu-archives.ae118f339ab4d3b32f1a69b9f7665aa2.svg";
export { ForwardRef as ReactComponent };